import React from "react";
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ptBr from "date-fns/locale/pt-BR";

function CustomDatePicker(props) {
  const {
    onChange,
    value,
    minDate,
    maxDate,
    dateFormat,
    showMonthYearPicker,
    ...rest
  } = { ...props };

  return (
    <DatePicker
      selected={value}
      onChange={onChange}
      locale={ptBr}
      className="custom-date-picker"
      minDate={minDate}
      maxDate={maxDate}
      placeholderText={"DD/MM/YYYY"}
      dateFormat={dateFormat}
      showMonthYearPicker={showMonthYearPicker}
      {...rest}
    />
  );
}

CustomDatePicker.defaultProps = {
  onChange: null,
  value: new Date(),
  minDate: null,
  maxDate: null,
  dateFormat: "MM/yyyy",
  showMonthYearPicker: false,
};

CustomDatePicker.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.objectOf(Date),
  minDate: PropTypes.objectOf(Date),
  maxDate: PropTypes.objectOf(Date),
  dateFormat: PropTypes.string,
  showMonthYearPicker: PropTypes.bool,
};

export default CustomDatePicker;
